import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import { EcrionProviderContext } from '../core/EcrionProvider/Provider';

var BlockPromptComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BlockPromptComponent, _React$Component);

  function BlockPromptComponent(props) {
    var _this;

    _classCallCheck(this, BlockPromptComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockPromptComponent).call(this, props));

    _this.unblockHistoryCallback = function () {};

    return _this;
  }

  _createClass(BlockPromptComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBlockHistory();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.when === this.props.when) return;
      this.updateBlockHistory();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unblockHistory();
      window.removeEventListener('beforeunload', this.showAlert);
    }
  }, {
    key: "showAlert",
    value: function showAlert(e) {
      e.returnValue = '';
    }
  }, {
    key: "updateBlockHistory",
    value: function updateBlockHistory() {
      var when = this.props.when;
      var history = this.props.routes && this.props.routes.history;

      if (when) {
        this.unblockHistory();
        if (history) this.unblockHistoryCallback = this.blockHistory();
        window.addEventListener('beforeunload', this.showAlert);
      } else {
        this.unblockHistory();

        this.unblockHistoryCallback = function () {};

        window.removeEventListener('beforeunload', this.showAlert);
      }
    }
  }, {
    key: "blockHistory",
    value: function blockHistory() {
      var history = this.props.routes && this.props.routes.history;
      var pathname = history && history.location.pathname;
      var leaveMessage = this.props.leaveMessage;
      return history.block(function (location) {
        if (pathname !== location.pathname) return leaveMessage;
      });
    }
  }, {
    key: "stopBlockingHistory",
    value: function stopBlockingHistory() {
      this.unblockHistory();

      this.unblockHistoryCallback = function () {};

      window.removeEventListener('beforeunload', this.showAlert);
    }
  }, {
    key: "unblockHistory",
    value: function unblockHistory() {
      this.unblockHistoryCallback();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return BlockPromptComponent;
}(React.Component);

var BlockPrompt = React.forwardRef(
/**
 * @param {import('./types').BlockPromptProps} props
 */
function (_ref, ref) {
  var when = _ref.when,
      leaveMessage = _ref.leaveMessage;
  return React.createElement(EcrionProviderContext.Consumer, null, function (_ref2) {
    var routes = _ref2.routes;
    return React.createElement(BlockPromptComponent, {
      ref: ref,
      routes: routes,
      when: when,
      leaveMessage: leaveMessage
    });
  });
});
BlockPrompt.defaultProps = {
  when: false,
  leaveMessage: 'You have unsaved changes. Are you sure you want to leave this page?'
};
export default BlockPrompt;